module.exports = __webpack_public_path__ + "img/client-6.4a957e00.png";